<template>
  <b-card no-body>
    <h3 slot="header" class="text-center">
      <i v-if="cardData.iconCode" v-bind:class="iconClass + cardData.iconCode"></i>
      <span v-if="cardData.iconCode">&nbsp;&nbsp;</span>
      <span class="text-primary">{{$t(cardData.i18nMenuName)}}</span>
    </h3>
    <b-list-group flush>
      <b-list-group-item
        v-for="router in cardData.routerItemList"
        :key="router.id"
        class="d-flex justify-content-between align-items-cente"
      >
        <!-- <router-link v-bind:to="{ name: 'emMenuList', params: { menuId: router.id}}" class="menu-title">           -->
        <!-- <router-link to="/em/admin/emMenuList?menuId=140" class="menu-title">           -->
        <router-link v-bind:to="{ path: router.url, query: { menuId: router.id, pathType: router.crudCode}}" class="menu-title">
          <i v-if="router.iconCode" v-bind:class="iconClass + router.iconCode"></i>
          <span >{{$t(router.i18nMenuName)}}</span>
          <!-- <span v-if="!router.dropdownItems" class="app-menu__label">{{$t(router.name)}}</span> -->
          <!--dropdown of components doesn't support {{$t()}}</i>          -->
          <!-- <b-dropdown v-if="router.dropdownItems" variant="link" v-bind:text="router.name">
            <b-dropdown-item
              v-for="dropdownItem in router.dropdownItems"
              :key="dropdownItem.id"
              @click="handleClickDropdownItem(dropdownItem.url)"
            >
              <i
                v-if="dropdownItem.cssIconClass"
                v-bind:class="iconClass + dropdownItem.cssIconClass"
              ></i>
              {{$t(dropdownItem.name)}}
            </b-dropdown-item>
          </b-dropdown> -->
        </router-link>
        <b-badge v-if="router.badge" pill variant="primary">{{router.badge}}</b-badge>
      </b-list-group-item>
    </b-list-group>
    <b-card-footer v-if="cardData.routerCardSetting" class="text-right">
      <router-link v-bind:to="{ path: cardData.routerCardSetting.url, query: { menuId: cardData.routerCardSetting.id}}" class="menu-title">
        <i
          v-if="cardData.routerCardSetting.iconCode"
          v-bind:class="iconClass + cardData.routerCardSetting.iconCode"
        ></i>
        <span v-if="cardData.routerCardSetting">{{$t(cardData.routerCardSetting.i18nMenuName)}}</span>
      </router-link>
    </b-card-footer>
  </b-card>
</template>

<script>
//import axios from "axios";

export default {
  name: "emCardRouter",
  props: {
    cardData: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      iconClass: "app-menu__icon fa "
    };
  }
};
</script>
